var React = require('react');

function Web (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.8231 1H1.17674C0.519854 1 0 1.52005 0 2.17674V18.2146C0 18.8441 0.520049 19.3914 1.17674 19.3914H10.701V21.5261H9.68837C8.48411 21.5261 7.49885 22.5114 7.49885 23.7156C7.49885 24.044 7.77261 24.2905 8.07368 24.2905H17.9263C18.2547 24.2905 18.5012 24.0167 18.5012 23.7156C18.5012 22.5114 17.5159 21.5261 16.3116 21.5261H15.299V19.3914H24.8233C25.4527 19.3914 26 18.8713 26 18.2146V2.17674C26 1.52 25.48 1 24.8233 1H24.8231ZM12.9999 18.1326C12.562 18.1326 12.1788 17.7768 12.1788 17.3115C12.1788 16.8736 12.5346 16.4904 12.9999 16.4904C13.4378 16.4904 13.821 16.8463 13.821 17.3115C13.821 17.7495 13.4379 18.1326 12.9999 18.1326ZM23.6462 15.2864H2.35359V3.35378H23.6462V15.2864Z"}));
}

Web.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26","fill":"color"};

module.exports = Web;

Web.default = Web;
